export const FRIDGE_CONTAINER = "fridge";
export const DELIVERY_PRDUCTS_STEP = 10;
